import Box from "@material-ui/core/Box";
import React from "react";
import { Controller, useForm } from "react-hook-form";

import { CustomButton } from "../../../scripts/components/renewal_v1/button";
import { CustomForm } from "../../../scripts/components/renewal_v1/form";
import { TextLink } from "../../../scripts/components/renewal_v1/text_link";
import { EntranceTemplate } from "../../../scripts/template/EntranceTemplate";
import theme from "../../../theme";
import {
  MIN_PASSWORD_LENGTH,
  MAX_PASSWORD_LENGTH,
  PASSWORD_MAX_LENGTH_MESSAGE,
  PASSWORD_MIN_LENGTH_MESSAGE,
  PASSWORD_REGEX,
  PASSWORD_REQUIRED_MESSAGE,
  PASSWORD_FORMAT_MESSAGE,
} from "../../../utilities/renewal_v1/const";

import { useResetPassword } from "./hooks/useResetPassword";

export const PasswordResetPage: React.FC = () => {
  const { resetPassword, loading, error } = useResetPassword();
  const { handleSubmit, errors, control, watch } = useForm();
  const password = watch("password");

  return (
    <EntranceTemplate title="パスワードリセット">
      <Box mt={4}>
        <form onSubmit={handleSubmit(resetPassword)}>
          <Box display="flex" flexDirection="column" style={{ gap: theme.spacing(2) }}>
            <Box textAlign="left">
              <Controller
                name="password"
                control={control}
                defaultValue={""}
                rules={{
                  required: PASSWORD_REQUIRED_MESSAGE,
                  maxLength: { value: MAX_PASSWORD_LENGTH, message: PASSWORD_MAX_LENGTH_MESSAGE },
                  minLength: { value: MIN_PASSWORD_LENGTH, message: PASSWORD_MIN_LENGTH_MESSAGE },
                  pattern: {
                    value: PASSWORD_REGEX,
                    message: PASSWORD_FORMAT_MESSAGE,
                  },
                }}
                render={({ ...field }) => (
                  <CustomForm
                    {...field}
                    label="新しいパスワード"
                    helperText="半角英数を含めた８文字以上で設定してください。"
                    type="password"
                    autoComplete="password"
                    error={!!errors.password}
                    errorText={Boolean(errors.password) && errors.password.message}
                    placeHolder="半角英数８文字"
                  />
                )}
              />
              <Controller
                name="password_confirmation"
                control={control}
                defaultValue={""}
                rules={{
                  required: PASSWORD_REQUIRED_MESSAGE,
                  maxLength: { value: MAX_PASSWORD_LENGTH, message: PASSWORD_MAX_LENGTH_MESSAGE },
                  minLength: { value: MIN_PASSWORD_LENGTH, message: PASSWORD_MIN_LENGTH_MESSAGE },
                  pattern: {
                    value: PASSWORD_REGEX,
                    message: PASSWORD_FORMAT_MESSAGE,
                  },
                  validate: (value) => value === password || "パスワードが一致しません",
                }}
                render={({ ...field }) => (
                  <CustomForm
                    {...field}
                    label="新しいパスワードをもう一度入力してください"
                    type="password"
                    autoComplete="password"
                    error={!!errors.password_confirmation}
                    errorText={Boolean(errors.password_confirmation) && errors.password_confirmation.message}
                    placeHolder="半角英数８文字"
                  />
                )}
              />
              {error && (
                <Box color="secondary.main" mb={3}>
                  {error}
                </Box>
              )}
            </Box>
            <CustomButton type="submit" customVariant="filled" fullWidth disabled={loading}>
              パスワードを変更する
            </CustomButton>
            <Box my={3} textAlign="center">
              <TextLink href="/login" underline>
                ログインに戻る
              </TextLink>
            </Box>
          </Box>
        </form>
      </Box>
    </EntranceTemplate>
  );
};
